import { Col, Row, Spinner } from 'react-bootstrap'

function Loading() {
  return (
    <>
      <div>
        <Row>
          <Col md={12}>
            <div
              style={{ height: '100vh' }}
              className="d-flex flex-column justify-content-center"
            >
              <div className="d-flex flex-row justify-content-center">
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex flex-row justify-content-center gap-2">
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="warning" />
                  </div>
                  <p
                    className="fw-bold text-center"
                    style={{ fontSize: '13px' }}
                  >
                    Loading...
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default Loading
